import React from 'react';
import { connect } from 'react-redux';
import BookmakersList from './components/BookmakersList';
import { actions as bookmakersInfoActions } from '../../common/bookmakersInfo';

import { actions as loginActions } from '../../common/loginPage';
import { selectors as userInfoSelectors } from '../../common/userInfo';
import bookmakersSorting from '../../common/utils/bookmakersSorting';
import { getCookie, setCookie } from '../../common/utils/cookie';
import { redirectToLoginBookmakerSelector } from '../bookmakersSwitcher.selectors';

export class ChooseBookmakerPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeModalsList: this.props.bookmakers.map(b => ({
                bookmakerFeed: b.feed, modalType: 'login', shouldBeVisible: false,
            })),
        }
    }

    onSelect = (feed, shouldShowModal) => {
        const {
            selectBookmaker,
            bookmakers,
            selectedBookmaker,
        } = this.props;
        if (feed !== selectedBookmaker) {
            selectBookmaker(
                feed,
                bookmakersSorting,
                bookmakers,
                shouldShowModal
            );
            if (getCookie('chooseBookie') !== feed) {
                const date = new Date();

                date.setFullYear(date.getFullYear() + 1);
                setCookie(
                    `chooseBookie=${feed}; ` +
                    `domain=.${location.host.split('.').slice(1).join('.')}; ` +
                    'path=/; ' +
                    `expires=${date.toUTCString()}`);
            }
        }
    }

    updateActiveModalsList = (bookmakerFeed, modalType) => {
        const updatedModalsList = this.state.activeModalsList.map((originalModalData) => {
            if (originalModalData.bookmakerFeed === bookmakerFeed && originalModalData.modalType === modalType) {
                return { ...originalModalData, shouldBeVisible: !originalModalData.shouldBeVisible };
            }

            return { ...originalModalData, shouldBeVisible: false };
        })
        this.setState(() => ({ activeModalsList: updatedModalsList }));
    }

    render() {
        const {
            bookmakers,
            selectedBookmaker,
            toggleBalanceVisibility,
            requestLogout,
        } = this.props;

        const {
            activeModalsList,
        } = this.state;

        if (!selectedBookmaker) {
            return null
        }

        return (
            <BookmakersList
                bookmakers={bookmakers}
                selectedBookmaker={selectedBookmaker}
                onSelect={this.onSelect}
                toggleBalanceVisibility={toggleBalanceVisibility}
                requestLogout={requestLogout}
                updateActiveModalsList={this.updateActiveModalsList}
                activeModalsList={activeModalsList}
            />
        );
    }
}

const userInfoSelectorsDictionary = {};
const getUserInfoSelector = (bookmaker) => {
    if (userInfoSelectorsDictionary[bookmaker]) {
        return userInfoSelectorsDictionary[bookmaker];
    }
    const selector = userInfoSelectors.createUserInfoSelector(() => bookmaker);
    userInfoSelectorsDictionary[bookmaker] = selector;
    return selector;
};

const sortBookmakers =
    (selectedBookmaker, bookmakersOrder) =>
        ({ feed: feed1 }, { feed: feed2 }) => {
            if (feed1 === selectedBookmaker) {
                return -1;
            }
            if (feed2 === selectedBookmaker) {
                return 1;
            }
            return bookmakersOrder.indexOf(feed1) - bookmakersOrder.indexOf(feed2);
        };

const mapStateToProps = (state, props) => {
    const {
        selectedBookmaker,
        bookmakersOrder,
    } = state.bookmakersInfo;
    let bookmakers = [...state.bookmakersList];
    bookmakers.sort(sortBookmakers(selectedBookmaker, bookmakersOrder));
    bookmakers = bookmakers.map(bookmaker => ({
        ...bookmaker,
        userInfo: getUserInfoSelector(bookmaker.feed)(state, props),
    }));
    return {
        bookmakers,
        selectedBookmaker,
        redirectToLoginBookmaker: redirectToLoginBookmakerSelector(state),
        onHistoryChanged: props.onHistoryChanged,
        selectedBookmakerFeed: props.selectedBookmakerFeed,
    };
};

const mapDispatchToProps = {
    selectBookmaker: bookmakersInfoActions.selectBookmaker,
    setBookmakersOrder: bookmakersInfoActions.setBookmakersOrder,
    toggleBalanceVisibility: bookmakersInfoActions.toggleBalanceVisibility,
    requestLogout: loginActions.requestLogout,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ChooseBookmakerPage);



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/chooseBookmakerPage/ChooseBookmakerPage.jsx